import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import tz from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(tz);

export default {
	methods: {
		getDateParam(yesterday = false) {
			let date = dayjs();

			if (process.server) {
				date = dayjs.utc();
			}

			if (yesterday) {
				date = date.subtract(1, "day");
			}

			return date.format("YYYY-MM-DD");
		},
	},
};
